/**
 * Paths into the Management tool.
 *
 * Portal has no react-router, so navigation is a full page load and these mirror
 * the `namespace :management` routes in config/routes.rb by hand. They live in one
 * place so the list's row links and the Edit User form cannot disagree about them.
 */
export const USERS_PATH = '/management/users';

export const userPath = (id) => `${USERS_PATH}/${id}`;

export const editUserPath = (id) => `${userPath(id)}/edit`;

export const removeAccountAccessPath = (id) =>
  `${userPath(id)}/remove_account_access`;

export const restoreAccountAccessPath = (id) =>
  `${userPath(id)}/restore_account_access`;

export const assignableAccountsPath = (id) =>
  `${userPath(id)}/assignable_accounts`;

export const addAccountAccessPath = (id) =>
  `${userPath(id)}/add_account_access`;
